// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { FileDownloadOutlined } from '@/constants/hardfin-standard-icons';
import { useToast } from '@/contexts/toast-context';
import { downloadFileByKey } from '@/file/utilities/download-file-by-key';
import { Link, Typography } from '@mui/material';

interface Props {
  fileKey: string;
  filename: string;
}

/**
 * Renders a filename as a button that downloads the file through the API so it
 * saves directly instead of opening a new tab.
 */
export function AuditFileDownloadLink(props: Props) {
  const { showToast } = useToast();
  const handleClick = () => {
    downloadFileByKey(props.fileKey).catch((error) => {
      Sentry.captureException(error);
      showToast({
        element: <Typography>Could not download the file</Typography>,
        severity: 'error',
      });
    });
  };

  return (
    <Link
      component="button"
      type="button"
      onClick={handleClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.25,
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {props.filename}
      <FileDownloadOutlined sx={{ fontSize: '0.9rem' }} color="action" />
    </Link>
  );
}
